// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8d8a4e94","977":"ac535634"}[chunkId] + ".chunk.js";
};